import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.SPACER }>;
}

const WizardSpacer: React.FC<Props> = ({ item }) => {
	return <div style={{ height: `${item.value}px` }} />;
};

export default WizardSpacer;
